<script>
    import LayerListSwitch from "../LayerList/LayerListSwitch.svelte";

    export let data;
    let visible = data.visible;
</script>

<LayerListSwitch
    label={data.name}
    bind:checked={$visible}
/>